import { DatePicker } from "antd";
import { BaseComponent } from "./baseComponent";

export class DateTimeField extends BaseComponent {
  constructor() {
    super('datetime');
  }
  public renderComponent(item: any, pipe: any): any {
    const {
      id, type, placeholder, cssClass, label,
      mandatory, mandatoryMessage,
      ...otherProps
    } = item;
    return <DatePicker key={id} placeholder={ pipe.t(placeholder) } label={ pipe.t(label) } className={ cssClass } showTime format="YYYY-MM-DD HH:mm:ss" {...otherProps} />
  }
};
